<template>
  <StaffLayout section="Bounced Emails" showHeader>
    <Loading v-if="isLoading" />
    <div v-else>
      <div class="mt-4" v-if="historyDetails?.length > 0">
        <div class="mb-4">
          Found {{ historyDetails?.length }}
          <span v-if="historyDetails?.length === MAX_RESULTS">most recent </span> emails sent that
          are reported back as bounced
        </div>
        <table class="table-auto w-full border-2 shadow text-sm">
          <thead class="font-sm font-bold">
            <tr>
              <td class="pl-3 w-0"></td>
              <td class="pl-3 py-2">Email</td>
              <td class="px-3">Status</td>
              <td class="px-3">Date</td>
            </tr>
          </thead>
          <template v-for="(alertEntry, i) in historyDetails" :key="i">
            <tr
              class="font-xs font-mono border-bottom-2 hover:border-sky-800 hover:bg-sky-300 cursor-pointer"
              :class="{ 'bg-stone-200': i % 2 === 0 }"
              @click="selectClick(alertEntry)"
            >
              <td class="pl-3">
                <div class="px-2 w-min">
                  <IHeroiconsOutlineChevronUp
                    class="mx-auto"
                    :class="{
                      'transform rotate-180':
                        alertEntry.alertHistoryDetailsId !== selectedHistoryId,
                    }"
                  />
                </div>
              </td>
              <td class="pl-3">{{ alertEntry.emailAddress }}</td>
              <td class="px-3">{{ alertEntry.eventType }}</td>
              <td class="px-3">{{ formatDateTime(alertEntry.timeStamp) }}</td>
            </tr>
            <template v-if="alertEntry.alertHistoryDetailsId === selectedHistoryId">
              <tr>
                <td :colspan="3" class="px-8 p-6">
                  <div class="font-bold">Full Details</div>
                  <pre class="whitespace-pre-wrap">{{
                    JSON.stringify(JSON.parse(alertEntry?.fullDetails ?? "{}"), null, 2)
                  }}</pre>
                </td>
              </tr>
            </template>
          </template>
        </table>
      </div>
      <div v-else class="mb-2">
        <span>-- No Alert History Found --</span>
      </div>
    </div>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useAlertStore } from "../../store/alertStore";
import { AlertHistoryDetailsDTO } from "../../store/generatedFetchClient";

const alertStore = useAlertStore();
var isLoading = ref(false);

var historyDetails = computed(() => alertStore.historyDetails);
const MAX_RESULTS = 50;

onMounted(loadData);

async function loadData() {
  isLoading.value = true;
  await alertStore.getEmailBounces(MAX_RESULTS);
  isLoading.value = false;
}

let selectedHistoryId = ref(-1);

function formatDateTime(date: any) {
  let d = new Date(date);
  let formatedDate = d.toDateString() + " " + d.toLocaleTimeString();
  return formatedDate === "Invalid Date" ? "" : formatedDate;
}

// Same item clicked twice => Toggle selection
let selectClick = (history: AlertHistoryDetailsDTO) =>
  (selectedHistoryId.value =
    history.alertHistoryDetailsId === selectedHistoryId.value ? -1 : history.alertHistoryDetailsId);
</script>
